export type DsPriceProps = {
  current: string;
  old?: string;
  saveLabel?: string;
  sale?: boolean;
  className?: string;
};

export function DsPrice({current, old, saveLabel, sale, className}: DsPriceProps) {
  const cls = ["cc-ds-price", className || ""].filter(Boolean).join(" ");
  const currentCls = ["cc-ds-price__current", sale ? "cc-ds-price__current--sale" : ""].filter(Boolean).join(" ");
  return (
    <div className={cls}>
      {old ? <span className="cc-ds-price__old">{old}</span> : null}
      <span className={currentCls}>{current}</span>
      {saveLabel ? <span className="cc-ds-price__save">{saveLabel}</span> : null}
    </div>
  );
}
